<template>
  <div class="course-create">
    <coach-header />
    <router-view />
  </div>
</template>

<script>
import CoachHeader from '@/components/CoachHeader';

export default {
    components: {
        CoachHeader,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/course/Create.vue